import axios, { AxiosError } from 'axios';
import { DataObject } from './dataObject';
import { Failure } from './failure';
import { AuthError, Canceled, NoInternetConnection, Unexpected, Violations } from './failures';
import { getErrorMessage } from './i18nErrors';

export function handleError<T>(e: AxiosError | any, fun?: () => DataObject<Failure, null>): DataObject<Failure, T | null> {
    console.log(e);
    if (!e) {
        return new DataObject(new Unexpected(), null);
    }
    if (axios.isCancel(e)) {
        return new DataObject(new Canceled());
    }
    if (e?.response?.status === 401) {
        if (e?.response?.data?.code === 'ACCOUNT_NOT_ACTIVE' || e?.response?.data?.detail === 'account.activation.not-active') {
            const message = getErrorMessage('AccountNotActive') || "Konto nie zostało jeszcze aktywowane. Sprawdź swoją skrzynkę e-mail i kliknij w link aktywacyjny.";
            return new DataObject(new Unexpected(message), null);
        }
        return new DataObject(new AuthError(), null);
    }

    if (e?.response?.status === 504) {
        return new DataObject(new NoInternetConnection(), null);
    }

    if (e?.response?.status === 403) {
        const detailMessage = e?.response?.data?.detail || e?.response?.data?.message;
        if (detailMessage) {
            return new DataObject(new Unexpected(detailMessage), null);
        }
        const authErrorMsg = getErrorMessage('authError') || "Brak uprawnień";
        return new DataObject(new Unexpected(authErrorMsg));
    }

    if (fun) {
        const ret: DataObject<Failure, null> = fun();

        if (ret) {
            return ret;
        }
    }
    if (e?.response?.data?.violations) {
        return new DataObject(new Violations(e?.response?.data?.violations));
    }

    const responseDetail = e?.response?.data?.detail || e?.response?.data?.message || e?.response?.data?.title || e?.response?.data?.error;
    return new DataObject(new Unexpected(responseDetail));
}
